<template>
  <v-dialog :value="value" max-width="400px" @input="$emit('input', $event)">
    <v-card class="pa-2">
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="text-subtitle-1 font-weight-bold">{{ title }}</span>
        <v-btn icon small @click="$emit('input', false)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-if="text" class="text-body-2">{{ text }}</v-card-text>

      <v-card-actions>
        <v-btn outlined color="#483CB9" class="flex-grow-1" @click="$emit('input', false)">
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="danger ? '#EC2E2E' : '#483CB9'"
          dark
          class="flex-grow-1"
          :loading="loading"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Замена window.confirm в модуле календаря — в стиле остальных диалогов модуля.
export default {
  name: 'ConfirmDialog',
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, required: true },
    text: { type: String, default: '' },
    confirmText: { type: String, default: 'Подтвердить' },
    cancelText: { type: String, default: 'Отмена' },
    danger: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
};
</script>
